var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackTriangleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.617007 8.41587C0.257901 9.13269 0.766326 10 1.58414 10H9.41569C10.2335 10 10.7419 9.13269 10.3828 8.41587L6.46706 0.599761C6.06638 -0.19992 4.93344 -0.19992 4.53275 0.599761L0.617007 8.41587Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackTriangleUp);
export default __webpack_public_path__ + "static/media/black-triangle-up.75d9d2a6ced6e486d28548d1debc3998.svg";
export { ForwardRef as ReactComponent };